<header
  class="d-flex w-100 align-items-center gap-2 mb-1 rounded"
  style="
    background-color: transparent;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
    border-left: 4px solid #206ccf;
  "
>
  <svg
    class="ms-2"
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M3.4 15.8C3.50506 15.8788 3.62461 15.9361 3.75182 15.9687C3.87903 16.0013 4.01142 16.0085 4.14142 15.99C4.27142 15.9714 4.39649 15.9274 4.50949 15.8605C4.62249 15.7936 4.72121 15.7051 4.8 15.6C5.40546 14.7927 6.19055 14.1375 7.09311 13.6862C7.99567 13.235 8.99091 13 10 13C11.0091 13 12.0043 13.235 12.9069 13.6862C13.8094 14.1375 14.5945 14.7927 15.2 15.6C15.3593 15.812 15.5963 15.952 15.8588 15.9893C16.1214 16.0266 16.388 15.958 16.6 15.7988C16.6756 15.7426 16.7425 15.6756 16.7987 15.6C17.4042 14.7927 18.1893 14.1375 19.0919 13.6862C19.9944 13.235 20.9897 13 21.9988 13C23.0078 13 24.0031 13.235 24.9056 13.6862C25.8082 14.1375 26.5933 14.7927 27.1987 15.6C27.358 15.8122 27.5951 15.9524 27.8578 15.9898C28.1204 16.0272 28.3872 15.9587 28.5994 15.7994C28.8115 15.6401 28.9518 15.403 28.9891 15.1404C29.0265 14.8777 28.958 14.6109 28.7987 14.3988C27.9136 13.2121 26.7332 12.2778 25.375 11.6888C26.1196 11.0089 26.6413 10.1199 26.8716 9.13826C27.1019 8.15664 27.03 7.12833 26.6654 6.18829C26.3009 5.24824 25.6606 4.44038 24.8287 3.87073C23.9967 3.30108 23.012 2.99625 22.0037 2.99625C20.9955 2.99625 20.0108 3.30108 19.1788 3.87073C18.3469 4.44038 17.7066 5.24824 17.3421 6.18829C16.9775 7.12833 16.9056 8.15664 17.1359 9.13826C17.3662 10.1199 17.8879 11.0089 18.6325 11.6888C17.6518 12.1128 16.7609 12.7199 16.0075 13.4775C15.2541 12.7199 14.3632 12.1128 13.3825 11.6888C14.1271 11.0089 14.6488 10.1199 14.8791 9.13826C15.1094 8.15664 15.0375 7.12833 14.6729 6.18829C14.3084 5.24824 13.6681 4.44038 12.8362 3.87073C12.0042 3.30108 11.0195 2.99625 10.0112 2.99625C9.00298 2.99625 8.01827 3.30108 7.18634 3.87073C6.35442 4.44038 5.71415 5.24824 5.34957 6.18829C4.98499 7.12833 4.91313 8.15664 5.14342 9.13826C5.37371 10.1199 5.89539 11.0089 6.64 11.6888C5.27581 12.2759 4.08963 13.2108 3.2 14.4C3.12121 14.5051 3.06388 14.6246 3.03129 14.7518C2.99869 14.879 2.99148 15.0114 3.01005 15.1414C3.02862 15.2714 3.07262 15.3965 3.13953 15.5095C3.20643 15.6225 3.29494 15.7212 3.4 15.8ZM22 5.00001C22.5933 5.00001 23.1734 5.17596 23.6667 5.5056C24.1601 5.83525 24.5446 6.30378 24.7716 6.85196C24.9987 7.40014 25.0581 8.00334 24.9424 8.58528C24.8266 9.16723 24.5409 9.70178 24.1213 10.1213C23.7018 10.5409 23.1672 10.8266 22.5853 10.9424C22.0033 11.0581 21.4001 10.9987 20.8519 10.7717C20.3038 10.5446 19.8352 10.1601 19.5056 9.66672C19.1759 9.17338 19 8.59336 19 8.00001C19 7.20436 19.3161 6.4413 19.8787 5.87869C20.4413 5.31608 21.2044 5.00001 22 5.00001ZM10 5.00001C10.5933 5.00001 11.1734 5.17596 11.6667 5.5056C12.1601 5.83525 12.5446 6.30378 12.7716 6.85196C12.9987 7.40014 13.0581 8.00334 12.9424 8.58528C12.8266 9.16723 12.5409 9.70178 12.1213 10.1213C11.7018 10.5409 11.1672 10.8266 10.5853 10.9424C10.0033 11.0581 9.40013 10.9987 8.85195 10.7717C8.30377 10.5446 7.83524 10.1601 7.50559 9.66672C7.17595 9.17338 7 8.59336 7 8.00001C7 7.20436 7.31607 6.4413 7.87868 5.87869C8.44129 5.31608 9.20435 5.00001 10 5.00001ZM25.375 24.6888C26.1196 24.0089 26.6413 23.1199 26.8716 22.1383C27.1019 21.1566 27.03 20.1283 26.6654 19.1883C26.3009 18.2482 25.6606 17.4404 24.8287 16.8707C23.9967 16.3011 23.012 15.9962 22.0037 15.9962C20.9955 15.9962 20.0108 16.3011 19.1788 16.8707C18.3469 17.4404 17.7066 18.2482 17.3421 19.1883C16.9775 20.1283 16.9056 21.1566 17.1359 22.1383C17.3662 23.1199 17.8879 24.0089 18.6325 24.6888C17.6518 25.1128 16.7609 25.7199 16.0075 26.4775C15.2541 25.7199 14.3632 25.1128 13.3825 24.6888C14.1271 24.0089 14.6488 23.1199 14.8791 22.1383C15.1094 21.1566 15.0375 20.1283 14.6729 19.1883C14.3084 18.2482 13.6681 17.4404 12.8362 16.8707C12.0042 16.3011 11.0195 15.9962 10.0112 15.9962C9.00298 15.9962 8.01827 16.3011 7.18634 16.8707C6.35442 17.4404 5.71415 18.2482 5.34957 19.1883C4.98499 20.1283 4.91313 21.1566 5.14342 22.1383C5.37371 23.1199 5.89539 24.0089 6.64 24.6888C5.27581 25.2759 4.08963 26.2108 3.2 27.4C3.12121 27.5051 3.06388 27.6246 3.03129 27.7518C2.99869 27.879 2.99148 28.0114 3.01005 28.1414C3.02862 28.2714 3.07262 28.3965 3.13953 28.5095C3.20643 28.6225 3.29494 28.7212 3.4 28.8C3.50506 28.8788 3.62461 28.9361 3.75182 28.9687C3.87903 29.0013 4.01142 29.0085 4.14142 28.99C4.27142 28.9714 4.39649 28.9274 4.50949 28.8605C4.62249 28.7936 4.72121 28.7051 4.8 28.6C5.40546 27.7927 6.19055 27.1375 7.09311 26.6862C7.99567 26.235 8.99091 26 10 26C11.0091 26 12.0043 26.235 12.9069 26.6862C13.8094 27.1375 14.5945 27.7927 15.2 28.6C15.3593 28.812 15.5963 28.952 15.8588 28.9893C16.1214 29.0266 16.388 28.958 16.6 28.7988C16.6756 28.7426 16.7425 28.6756 16.7987 28.6C17.4042 27.7927 18.1893 27.1375 19.0919 26.6862C19.9944 26.235 20.9897 26 21.9988 26C23.0078 26 24.0031 26.235 24.9056 26.6862C25.8082 27.1375 26.5933 27.7927 27.1987 28.6C27.358 28.8122 27.5951 28.9524 27.8578 28.9898C28.1204 29.0272 28.3872 28.9587 28.5994 28.7994C28.8115 28.6401 28.9518 28.403 28.9891 28.1404C29.0265 27.8777 28.958 27.6109 28.7987 27.3988C27.9136 26.2121 26.7332 25.2778 25.375 24.6888ZM10 18C10.5933 18 11.1734 18.176 11.6667 18.5056C12.1601 18.8352 12.5446 19.3038 12.7716 19.852C12.9987 20.4001 13.0581 21.0033 12.9424 21.5853C12.8266 22.1672 12.5409 22.7018 12.1213 23.1213C11.7018 23.5409 11.1672 23.8266 10.5853 23.9424C10.0033 24.0581 9.40013 23.9987 8.85195 23.7717C8.30377 23.5446 7.83524 23.1601 7.50559 22.6667C7.17595 22.1734 7 21.5934 7 21C7 20.2044 7.31607 19.4413 7.87868 18.8787C8.44129 18.3161 9.20435 18 10 18ZM22 18C22.5933 18 23.1734 18.176 23.6667 18.5056C24.1601 18.8352 24.5446 19.3038 24.7716 19.852C24.9987 20.4001 25.0581 21.0033 24.9424 21.5853C24.8266 22.1672 24.5409 22.7018 24.1213 23.1213C23.7018 23.5409 23.1672 23.8266 22.5853 23.9424C22.0033 24.0581 21.4001 23.9987 20.8519 23.7717C20.3038 23.5446 19.8352 23.1601 19.5056 22.6667C19.1759 22.1734 19 21.5934 19 21C19 20.2044 19.3161 19.4413 19.8787 18.8787C20.4413 18.3161 21.2044 18 22 18Z"
      fill="#206CCF"
    />
  </svg>
  <h4 class="fs-5 mt-3">Família</h4>
</header>

<form class="px-3 border rounded">
  <div class="py-4">
    <label class="form-label fs-6"> Você tem cônjuge?</label>
    <div class="d-flex flex-row">
      <div class="border hideradio">
        <input
          type="radio"
          class="px-4 py-2 border d-none"
          [value]="true"
          id="radio-1"
          name="married.isSelected"
          [value]="1"
          [(ngModel)]="familyData.has_spouse"
          (ngModelChange)="onFieldChange()"
          [checked]="familyData.has_spouse == 1"
        />
        <label class="form-check-label" for="radio-1">Sim</label>
      </div>

      <div class="border hideradio">
        <input
          type="radio"
          class="form-check-input d-none"
          [value]="false"
          id="radio-2"
          name="married.isSelected"
          [value]="0"
          [(ngModel)]="familyData.has_spouse"
          (ngModelChange)="onFieldChange()"
          [checked]="familyData.has_spouse == 0"
        />
        <label class="form-check-label" for="radio-2">Não</label>
      </div>
    </div>
  </div>

  <div *ngIf="familyData.has_spouse" class="py-4 border-top">
    <label class="form-label fs-6">Anotações</label>
    <input
      id="marrige-notes"
      type="text"
      class="form-control mt-2 p-2"
      maxlength="500"
      placeholder="Aqui você pode colocar qualquer anotação pertinente para a seção."
      name="married.notes"
      [(ngModel)]="familyData.spouse_notes"
      (ngModelChange)="onFieldChange()"
    />
    <div class="form-text">Máximo 500 caracteres.</div>
  </div>

  <div class="border-top py-4">
    <label class="form-label fs-6">Você possui filhos ou dependentes?</label>
    <div class="d-flex flex-row">
      <div class="border hideradio">
        <input
          class="px-4 py-2 border d-none"
          type="radio"
          [value]="true"
          id="radio-3"
          name="children"
          [value]="1"
          [(ngModel)]="familyData.has_dependents"
          (ngModelChange)="onFieldChange()"
          [checked]="familyData.has_dependents == 1"
        />
        <label for="radio-3">Sim</label>
      </div>
      <div class="border hideradio">
        <input
          class="px-4 py-2 border d-none"
          type="radio"
          [value]="false"
          id="radio-4"
          name="children"
          [value]="0"
          [(ngModel)]="familyData.has_dependents"
          (ngModelChange)="onFieldChange()"
          [checked]="familyData.has_dependents == 0"
        />
        <label for="radio-4">Não</label>
      </div>
    </div>
  </div>

  <div *ngIf="familyData.has_dependents" class="border-top py-4">
    <label class="form-label fs-6">Anotações</label>
    <input
      id="children-notes"
      type="text"
      class="form-control mt-2 p-2"
      maxlength="500"
      placeholder="Aqui você pode colocar qualquer anotação pertinente para a seção."
      name="children.notes"
      [(ngModel)]="familyData.dependents_notes"
      (ngModelChange)="onFieldChange()"
    />
    <div class="form-text">Máximo 500 caracteres.</div>
  </div>

  <div *ngIf="familyData.has_dependents" class="py-4 border-top">
    <label class="form-label fs-6"
      >Você investe algo para o futuro deles?</label
    >
    <div class="d-flex flex-row py-2">
      <div class="border hideradio">
        <input
          class="px-4 py-2 border d-none"
          type="radio"
          [value]="true"
          id="radio-5"
          name="investimentChild"
          [value]="1"
          [(ngModel)]="familyData.invest_in_future"
          (ngModelChange)="onFieldChange()"
          [checked]="familyData.invest_in_future == 1"
        />
        <label for="radio-5">Sim</label>
      </div>
      <div class="border hideradio">
        <input
          class="px-4 py-2 border d-none"
          type="radio"
          [value]="false"
          id="radio-6"
          name="investimentChild"
          [value]="0"
          [(ngModel)]="familyData.invest_in_future"
          (ngModelChange)="onFieldChange()"
          [checked]="familyData.invest_in_future == 0"
        />
        <label for="radio-6">Não</label>
      </div>
    </div>
  </div>

  <div
    *ngIf="familyData.invest_in_future && familyData.has_dependents"
    class="border-top py-4"
  >
    <label class="form-label fs-6">Anotações</label>
    <input
      id="future-notes"
      type="text"
      class="form-control mt-2 p-2"
      maxlength="500"
      placeholder="Aqui você pode colocar qualquer anotação pertinente para a seção."
      name="married.notes"
      [(ngModel)]="familyData.invest_notes"
      (ngModelChange)="onFieldChange()"
    />

    <div class="form-text">Máximo 500 caracteres.</div>
  </div>
  <!-- <div class="w-100 d-flex justify-content-end mb-2">
    <button
      class="btn btn-primary mt-3"
      [ngClass]="saveButtonClass"
      [disabled]="isSaving"
      (click)="saveForm()"
    >
      {{ saveButtonText }}
    </button>
  </div> -->
</form>

<app-loading *ngIf="isLoading"></app-loading>
